import  { memo } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { BzModal, BzModalHeader, BzModalBody, BzButton, BzModalFooter } from '../../../components';
import { useDispatch, useSelector } from 'react-redux';
import { handleModal, handleModalData } from '../../../redux/actions/modals';
//BREEZE-5912 : Order Cart for Derivative segment : ManasaB : 28-04-2025 : Banned scrip alert modal - Start
const BannedScripModal = ({ setBIsBannedScripAccepted, setBIsBannedScripRejected }) => {
    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);
    const modalData = useSelector(state => state?.modals?.modalData);

    const handleYesClick = () => {
        dispatch(handleModal([{ 'BANNED_SCRIP_MODAL': false }]), true);
        if (modalData?.data?.buySellClick) {
            dispatch(handleModalData({ data: { addScrip: true, scripInfo: modalData?.data?.scripInfo, strBuySell: modalData?.data?.strBuySell } }));
        }
        else {
            setBIsBannedScripAccepted(true);
        }
    };
    const handleNoClick = () => {
        dispatch(handleModal([{ 'BANNED_SCRIP_MODAL': false }]), true);
        dispatch(handleModalData({ data: { rejectScrip: true } }));
        setBIsBannedScripRejected(true);
    };
    const handleClose = () => {
        dispatch(handleModal([{ 'BANNED_SCRIP_MODAL': false }]), true);
        dispatch(handleModalData({data : {}}))
    }
    return (
        <>
            <BzModal data-testid="ordercart--banscrip-modal" size='sm' show={modals['BANNED_SCRIP_MODAL']} className='modal-breeze'>
                <BzModalHeader className='modaltabs-header'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col className='d-flex justify-content-start align-items-center'>
                                <div data-testid="ordercart-banscrip-title" className='font-medium font-size4 color-text'>Banned Scrips</div>
                            </Col>
                            <Col md={1} className='d-flex justify-content-end align-items-center'>
                                <div className='icon-16 icon-dark icon-close' onClick={handleClose}></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody>
                    <Container fluid className='p-0'>
                        <Row className='g-0 mb-2'>
                            <Col className='d-flex justify-content-start'>
                                <div className='font-regular font-size4 color-text'>The following selected scrip(s) are currently on banned list</div>
                            </Col>
                        </Row>
                        {modalData?.data?.bannedMessage?.map(eachScrip => {
                            return (<>
                                <div className="mb-2" >
                                    <span className='font-medium font-size4 color-text text-uppercase'>{eachScrip.name}</span>
                                    <span className='font-regular font-size2 color-subtext'>{eachScrip.expiry}</span>
                                </div>
                            </>
                            );
                        })}
                        <Row className='g-0 mt-2'>
                            <Col className='d-flex justify-content-start'>
                                <div className='font-regular font-size3 color-text'>Do you want to proceed with placing an order for these scrips?</div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalBody>
                <BzModalFooter>
                    <Container fluid className='p-0 m-0'>
                        <Row className='g-0 justify-content-end'>
                            <Col md={3}>&nbsp;</Col>
                            <Col md={9} className='d-flex align-items-center'>
                                <BzButton data-testid="ordercart-banscrip-no-button" className='btn btn-md btn-block btn-outline me-3' onClick={handleNoClick}>No</BzButton>
                                <BzButton data-testid="ordercart-banscrip-yes-button" className='btn btn-md btn-block btn-primary' onClick={handleYesClick}>Yes</BzButton>
                            </Col>
                        </Row>
                    </Container>
                </BzModalFooter>
            </BzModal>
        </>
    );
};

export default memo(BannedScripModal);

//BREEZE-5912 : Order Cart for Derivative segment : ManasaB : 28-04-2025 : Banned scrip alert modal - End